<!-- Hero Start -->
<section class="bg-half-170 bg-light d-table w-100" id="home">
  <div class="container">
    <div class="row mt-5 justify-content-center">
      <div class="col-lg-12 text-center">
        <div class="pages-heading">
          <h4 class="title mb-0"> Branded T-Shirts </h4>
        </div>
      </div><!--end col-->
    </div><!--end row-->

    <div class="position-breadcrumb">
      <nav aria-label="breadcrumb" class="d-inline-block">
        <ul class="breadcrumb rounded shadow mb-0 px-4 py-2">
          <li class="breadcrumb-item"><a routerLink="/index">Landrick</a></li>
          <li class="breadcrumb-item"><a routerLink="/index-shop">Shop</a></li>
          <li class="breadcrumb-item active" aria-current="page">Product Details</li>
        </ul>
      </nav>
    </div>
  </div> <!--end container-->
</section><!--end section-->
<!--end section-->
<div class="position-relative">
  <div class="shape overflow-hidden text-color-white">
    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
    </svg>
  </div>
</div>
<!-- Hero End -->

<section class="section pb-0">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-md-5">
        <owl-carousel-o id="customer-testi" [options]="customOptions">
          <ng-template carouselSlide>
            <div class="tiny-slide">
              <div class="tiny-slide"><img src="assets/images/shop/product/single-2.jpg" class="img-fluid rounded"
                  alt=""></div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="tiny-slide">
              <div class="tiny-slide"><img src="assets/images/shop/product/single-3.jpg" class="img-fluid rounded"
                  alt=""></div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="tiny-slide">
              <div class="tiny-slide"><img src="assets/images/shop/product/single-4.jpg" class="img-fluid rounded"
                  alt=""></div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="tiny-slide">
              <div class="tiny-slide"><img src="assets/images/shop/product/single-5.jpg" class="img-fluid rounded"
                  alt=""></div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="tiny-slide">
              <div class="tiny-slide"><img src="assets/images/shop/product/single-6.jpg" class="img-fluid rounded"
                  alt=""></div>
            </div>
          </ng-template>
        </owl-carousel-o>
      </div>
      <!--end col-->

      <div class="col-md-7 mt-4 mt-sm-0 pt-2 pt-sm-0">
        <div class="section-title ms-md-4">
          <h4 class="title">Branded T-Shirts</h4>
          <h5 class="text-muted">$21.00 <del class="text-danger ms-2">$25.00</del> </h5>
          <ul class="list-unstyled text-warning h5 mb-0">
            <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
            <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
            <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
            <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
            <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
          </ul>

          <h5 class="mt-4 py-2">Overview :</h5>
          <p class="text-muted">Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero exercitationem, unde
            molestiae sint quae inventore atque minima natus fugiat nihil quisquam voluptates ea omnis. Modi laborum
            soluta tempore unde accusantium.</p>

          <ul class="list-unstyled text-muted">
            <li class="mb-0"><span class="text-primary h5 me-2"><i class="uil uil-check-circle align-middle"></i></span>
              Digital Marketing Solutions for Tomorrow</li>
            <li class="mb-0"><span class="text-primary h5 me-2"><i class="uil uil-check-circle align-middle"></i></span>
              Our Talented &amp; Experienced Marketing Agency</li>
            <li class="mb-0"><span class="text-primary h5 me-2"><i class="uil uil-check-circle align-middle"></i></span>
              Create your own skin to match your brand</li>
          </ul>

          <div class="row mt-4 pt-2">
            <div class="col-lg-6 col-12">
              <div class="d-flex align-items-center">
                <h6 class="mb-0">Your Size:</h6>
                <ul class="list-unstyled mb-0 ms-3">
                  <li class="list-inline-item"><a href="javascript:void(0)" class="btn btn-icon btn-soft-primary">S</a>
                  </li>
                  <li class="list-inline-item ms-2"><a href="javascript:void(0)"
                      class="btn btn-icon btn-soft-primary">M</a></li>
                  <li class="list-inline-item ms-2"><a href="javascript:void(0)"
                      class="btn btn-icon btn-soft-primary">L</a></li>
                  <li class="list-inline-item ms-2"><a href="javascript:void(0)"
                      class="btn btn-icon btn-soft-primary">XL</a></li>
                </ul>
              </div>
            </div>
            <!--end col-->

            <div class="col-lg-6 col-12 mt-4 mt-lg-0">
              <div class="d-flex shop-list align-items-center">
                <h6 class="mb-0">Quantity:</h6>
                <div class="qty-icons ms-3">
                  <button onclick="this.parentNode.querySelector('input[type=number]').stepDown()"
                    class="btn btn-icon btn-soft-primary minus">-</button>
                  <input min="0" name="quantity" value="0" type="number"
                    class="btn btn-icon btn-soft-primary qty-btn quantity m-1">
                  <button onclick="this.parentNode.querySelector('input[type=number]').stepUp()"
                    class="btn btn-icon btn-soft-primary plus">+</button>
                </div>
              </div>
            </div>
            <!--end col-->
          </div>
          <!--end row-->

          <div class="mt-4 pt-2">
            <a href="javascript:void(0)" class="btn btn-primary">Shop Now</a>
            <a routerLink="/shop-cart" class="btn btn-soft-primary ms-2">Add to Cart</a>
          </div>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->

  <div class="container mt-100 mt-60">
    <div class="row">
      <div class="col-12">
        <ul ngbNav #nav="ngbNav"
          class="nav nav-pills shadow flex-column flex-sm-row d-md-inline-flex mb-0 p-1 rounded position-relative overflow-hidden"
          id="pills-tab" role="tablist">
          <li ngbNavItem class="nav-item m-1">
            <a ngbNavLink class="nav-link py-2 px-5 rounded">
              <div class="text-center">
                <h6 class="mb-0">Description</h6>
              </div>
            </a>
            <ng-template ngbNavContent>
              <div class="row">
                <p class="text-muted mb-0">Due to its widespread use as filler text for layouts, non-readability is of
                  great importance: human perception is tuned to recognize certain patterns and repetitions in texts. If
                  the distribution of letters and 'words' is random, the reader will not be distracted from making a
                  neutral judgement on the visual impact and readability of the typefaces (typography), or the
                  distribution of text on the page (layout or type area). For this reason, dummy text usually consists
                  of a more or less random series of words or syllables.</p>
              </div>
            </ng-template>
          </li>
          <li ngbNavItem class="nav-item m-1">
            <a ngbNavLink class="nav-link py-2 px-5 rounded">
              <div class="text-center">
                <h6 class="mb-0">Additional Information</h6>
              </div>
            </a>
            <ng-template ngbNavContent>
              <div class="row">
                <table class="table">
                  <tbody>
                    <tr>
                      <td style="width: 100px;">Color</td>
                      <td class="text-muted">Red, White, Black, Orange</td>
                    </tr>

                    <tr>
                      <td>Material</td>
                      <td class="text-muted">Cotton</td>
                    </tr>

                    <tr>
                      <td>Size</td>
                      <td class="text-muted">S, M, L, XL, XXL</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-template>
          </li>
          <li ngbNavItem class="nav-item m-1">
            <a ngbNavLink class="nav-link py-2 px-5 rounded">
              <div class="text-center">
                <h6 class="mb-0">Review</h6>
              </div>
            </a>
            <ng-template ngbNavContent>
              <div class="row">
                <div class="col-lg-6">
                  <ul class="media-list list-unstyled mb-0">
                    <li>
                      <div class="d-flex justify-content-between">
                        <div class="d-flex align-items-center">
                          <a class="pe-3" href="javascript:void(0)">
                            <img src="assets/images/client/01.jpg"
                              class="img-fluid avatar avatar-md-sm rounded-circle shadow" alt="img">
                          </a>
                          <div class="flex-1 commentor-detail">
                            <h6 class="mb-0"><a href="javascript:void(0)" class="text-dark media-heading">Lorenzo
                                Peterson</a></h6>
                            <small class="text-muted">15th August, 2019 at 01:25 pm</small>
                          </div>
                        </div>
                        <ul class="list-unstyled mb-0">
                          <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                          <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                          <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                          <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                          <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                        </ul>
                      </div>
                      <div class="mt-3">
                        <p class="text-muted fst-italic p-3 bg-light rounded">" Awesome product "</p>
                      </div>
                    </li>

                    <li class="mt-4">
                      <div class="d-flex justify-content-between">
                        <div class="d-flex align-items-center">
                          <a class="pe-3" href="javascript:void(0)">
                            <img src="assets/images/client/02.jpg"
                              class="img-fluid avatar avatar-md-sm rounded-circle shadow" alt="img">
                          </a>
                          <div class="flex-1 commentor-detail">
                            <h6 class="mb-0"><a href="javascript:void(0)" class="media-heading text-dark">Tammy
                                Camacho</a></h6>
                            <small class="text-muted">15th August, 2019 at 05:44 pm</small>
                          </div>
                        </div>
                        <ul class="list-unstyled mb-0">
                          <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                          <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                          <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                          <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                          <li class="list-inline-item"><i class="mdi mdi-star-outline text-warning"></i></li>
                        </ul>
                      </div>
                      <div class="mt-3">
                        <p class="text-muted fst-italic p-3 bg-light rounded mb-0">" Good "</p>
                      </div>
                    </li>
                  </ul>
                </div>
                <!--end col-->

                <div class="col-lg-6 mt-4 mt-lg-0 pt-2 pt-lg-0">
                  <form class="ms-lg-4">
                    <div class="row">
                      <div class="col-12">
                        <h5>Add your review:</h5>
                      </div>
                      <div class="col-12 mt-4">
                        <h6 class="small fw-bold">Your Rating:</h6>
                        <a href="javascript:void(0)" class="d-inline-block me-3">
                          <ul class="list-unstyled mb-0 small">
                            <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                            <li class="list-inline-item"><i class="mdi mdi-star-outline text-warning"></i></li>
                            <li class="list-inline-item"><i class="mdi mdi-star-outline text-warning"></i></li>
                            <li class="list-inline-item"><i class="mdi mdi-star-outline text-warning"></i></li>
                            <li class="list-inline-item"><i class="mdi mdi-star-outline text-warning"></i></li>
                          </ul>
                        </a>

                        <a href="javascript:void(0)" class="d-inline-block me-3">
                          <ul class="list-unstyled mb-0 small">
                            <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                            <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                            <li class="list-inline-item"><i class="mdi mdi-star-outline text-warning"></i></li>
                            <li class="list-inline-item"><i class="mdi mdi-star-outline text-warning"></i></li>
                            <li class="list-inline-item"><i class="mdi mdi-star-outline text-warning"></i></li>
                          </ul>
                        </a>

                        <a href="javascript:void(0)" class="d-inline-block me-3">
                          <ul class="list-unstyled mb-0 small">
                            <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                            <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                            <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                            <li class="list-inline-item"><i class="mdi mdi-star-outline text-warning"></i></li>
                            <li class="list-inline-item"><i class="mdi mdi-star-outline text-warning"></i></li>
                          </ul>
                        </a>

                        <a href="javascript:void(0)" class="d-inline-block me-3">
                          <ul class="list-unstyled mb-0 small">
                            <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                            <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                            <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                            <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                            <li class="list-inline-item"><i class="mdi mdi-star-outline text-warning"></i></li>
                          </ul>
                        </a>

                        <a href="javascript:void(0)" class="d-inline-block">
                          <ul class="list-unstyled mb-0 small">
                            <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                            <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                            <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                            <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                            <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                          </ul>
                        </a>
                      </div>
                      <div class="col-md-12 mt-3">
                        <div class="mb-3">
                          <label class="form-label">Your Review:</label>
                          <div class="form-icon position-relative">
                            <i-feather name="message-circle" class="fea icon-sm icons"></i-feather>
                            <textarea id="message" placeholder="Your Comment" rows="5" name="message"
                              class="form-control ps-5" required=""></textarea>
                          </div>
                        </div>
                      </div>
                      <!--end col-->

                      <div class="col-lg-6">
                        <div class="mb-3">
                          <label class="form-label">Name <span class="text-danger">*</span></label>
                          <div class="form-icon position-relative">
                            <i-feather name="user" class="fea icon-sm icons"></i-feather>
                            <input id="name" name="name" type="text" placeholder="Name" class="form-control ps-5"
                              required="">
                          </div>
                        </div>
                      </div>
                      <!--end col-->

                      <div class="col-lg-6">
                        <div class="mb-3">
                          <label class="form-label">Your Email <span class="text-danger">*</span></label>
                          <div class="form-icon position-relative">
                            <i-feather name="mail" class="fea icon-sm icons"></i-feather>
                            <input id="email" type="email" placeholder="Email" name="email" class="form-control ps-5"
                              required="">
                          </div>
                        </div>
                      </div>
                      <!--end col-->

                      <div class="col-md-12">
                        <div class="send d-grid">
                          <button type="submit" class="btn btn-primary">Submit</button>
                        </div>
                      </div>
                      <!--end col-->
                    </div>
                    <!--end row-->
                  </form>
                  <!--end form-->
                </div>
                <!--end col-->
              </div>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="col-12 tab-content mt-5"></div>
      </div>
    </div>
  </div>

  <div class="container mt-100 mt-60">
    <div class="row">
      <div class="col-12">
        <h5 class="mb-0">Related Products</h5>
      </div>
      <!--end col-->

      <div class="col-12 mt-4">
        <owl-carousel-o id="customer-testi" [options]="customOptions">
          <ng-template carouselSlide>
            <div class="card shop-list border-0 position-relative overflow-hidden m-2">
              <div class="shop-image position-relative overflow-hidden rounded shadow">
                <a routerLink="/shop-product-detail"><img src="assets/images/shop/product/s1.jpg" class="img-fluid"
                    alt=""></a>
                <a routerLink="/shop-product-detail" class="overlay-work">
                  <img src="assets/images/shop/product/s-1.jpg" class="img-fluid" alt="">
                </a>
                <ul class="list-unstyled shop-icons">
                  <li><a href="javascript:void(0)" class="btn btn-icon btn-pills btn-soft-danger">
                      <i-feather name="heart" class="icons"></i-feather>
                    </a></li>
                  <li class="mt-2"><a routerLink="/shop-product-detail" class="btn btn-icon btn-pills btn-soft-primary">
                      <i-feather name="eye" class="icons"></i-feather>
                    </a></li>
                  <li class="mt-2"><a routerLink="/shop-cart" class="btn btn-icon btn-pills btn-soft-warning">
                      <i-feather name="shopping-cart" class="icons"></i-feather>
                    </a></li>
                </ul>
              </div>
              <div class="card-body content pt-4 p-2">
                <a routerLink="/shop-product-detail" class="text-dark product-name h6">Branded T-Shirt</a>
                <div class="d-flex justify-content-between mt-1">
                  <h6 class="text-muted small fst-italic mb-0 mt-1">$16.00 <del class="text-danger ms-2">$21.00</del>
                  </h6>
                  <ul class="list-unstyled text-warning mb-0">
                    <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                    <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                    <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                    <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                    <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                  </ul>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="card shop-list border-0 position-relative overflow-hidden m-2">
              <div class="shop-image position-relative overflow-hidden rounded shadow">
                <a routerLink="/shop-product-detail"><img src="assets/images/shop/product/s3.jpg" class="img-fluid"
                    alt=""></a>
                <a routerLink="/shop-product-detail" class="overlay-work">
                  <img src="assets/images/shop/product/s-3.jpg" class="img-fluid" alt="">
                </a>
                <ul class="list-unstyled shop-icons">
                  <li><a href="javascript:void(0)" class="btn btn-icon btn-pills btn-soft-danger">
                      <i-feather name="heart" class="icons"></i-feather>
                    </a></li>
                  <li class="mt-2"><a routerLink="/shop-product-detail" class="btn btn-icon btn-pills btn-soft-primary">
                      <i-feather name="eye" class="icons"></i-feather>
                    </a></li>
                  <li class="mt-2"><a routerLink="/shop-cart" class="btn btn-icon btn-pills btn-soft-warning">
                      <i-feather name="shopping-cart" class="icons"></i-feather>
                    </a></li>
                </ul>
              </div>
              <div class="card-body content pt-4 p-2">
                <a routerLink="/shop-product-detail" class="text-dark product-name h6">Elegent Watch</a>
                <div class="d-flex justify-content-between mt-1">
                  <h6 class="text-muted small fst-italic mb-0 mt-1">$5.00 <span class="text-success ms-1">30%
                      off</span> </h6>
                  <ul class="list-unstyled text-warning mb-0">
                    <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                    <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                    <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                    <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                    <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                  </ul>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="card shop-list border-0 position-relative overflow-hidden m-2">
              <div class="shop-image position-relative overflow-hidden rounded shadow">
                <a routerLink="/shop-product-detail"><img src="assets/images/shop/product/s6.jpg" class="img-fluid"
                    alt=""></a>
                <a routerLink="/shop-product-detail" class="overlay-work">
                  <img src="assets/images/shop/product/s-6.jpg" class="img-fluid" alt="">
                </a>
                <ul class="list-unstyled shop-icons">
                  <li><a href="javascript:void(0)" class="btn btn-icon btn-pills btn-soft-danger">
                      <i-feather name="heart" class="icons"></i-feather>
                    </a></li>
                  <li class="mt-2"><a routerLink="/shop-product-detail" class="btn btn-icon btn-pills btn-soft-primary">
                      <i-feather name="eye" class="icons"></i-feather>
                    </a></li>
                  <li class="mt-2"><a routerLink="/shop-cart" class="btn btn-icon btn-pills btn-soft-warning">
                      <i-feather name="shopping-cart" class="icons"></i-feather>
                    </a></li>
                </ul>
              </div>
              <div class="card-body content pt-4 p-2">
                <a routerLink="/shop-product-detail" class="text-dark product-name h6">Elegent Mug</a>
                <div class="d-flex justify-content-between mt-1">
                  <h6 class="text-muted small fst-italic mb-0 mt-1">$4.50 <del class="text-danger ms-2">$6.50</del>
                  </h6>
                  <ul class="list-unstyled text-warning mb-0">
                    <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                    <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                    <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                    <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                    <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                  </ul>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="card shop-list border-0 position-relative overflow-hidden m-2">
              <div class="shop-image position-relative overflow-hidden rounded shadow">
                <a routerLink="/shop-product-detail"><img src="assets/images/shop/product/s8.jpg" class="img-fluid"
                    alt=""></a>
                <a routerLink="/shop-product-detail" class="overlay-work">
                  <img src="assets/images/shop/product/s-8.jpg" class="img-fluid" alt="">
                </a>
                <ul class="list-unstyled shop-icons">
                  <li><a href="javascript:void(0)" class="btn btn-icon btn-pills btn-soft-danger">
                      <i-feather name="heart" class="icons"></i-feather>
                    </a></li>
                  <li class="mt-2"><a routerLink="/shop-product-detail" class="btn btn-icon btn-pills btn-soft-primary">
                      <i-feather name="eye" class="icons"></i-feather>
                    </a></li>
                  <li class="mt-2"><a routerLink="/shop-cart" class="btn btn-icon btn-pills btn-soft-warning">
                      <i-feather name="shopping-cart" class="icons"></i-feather>
                    </a></li>
                </ul>
              </div>
              <div class="card-body content pt-4 p-2">
                <a routerLink="/shop-product-detail" class="text-dark product-name h6">Wooden Stools</a>
                <div class="d-flex justify-content-between mt-1">
                  <h6 class="text-muted small fst-italic mb-0 mt-1">$22.00 <del class="text-danger ms-2">$25.00</del>
                  </h6>
                  <ul class="list-unstyled text-warning mb-0">
                    <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                    <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                    <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                    <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                    <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                  </ul>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="card shop-list border-0 position-relative overflow-hidden m-2">
              <div class="shop-image position-relative overflow-hidden rounded shadow">
                <a routerLink="/shop-product-detail"><img src="assets/images/shop/product/s14.jpg" class="img-fluid"
                    alt=""></a>
                <a routerLink="/shop-product-detail" class="overlay-work">
                  <img src="assets/images/shop/product/s-14.jpg" class="img-fluid" alt="">
                </a>
                <ul class="list-unstyled shop-icons">
                  <li><a href="javascript:void(0)" class="btn btn-icon btn-pills btn-soft-danger">
                      <i-feather name="heart" class="icons"></i-feather>
                    </a></li>
                  <li class="mt-2"><a routerLink="/shop-product-detail" class="btn btn-icon btn-pills btn-soft-primary">
                      <i-feather name="eye" class="icons"></i-feather>
                    </a></li>
                  <li class="mt-2"><a routerLink="/shop-cart" class="btn btn-icon btn-pills btn-soft-warning">
                      <i-feather name="shopping-cart" class="icons"></i-feather>
                    </a></li>
                </ul>
              </div>
              <div class="card-body content pt-4 p-2">
                <a routerLink="/shop-product-detail" class="text-dark product-name h6">Women Block Heels</a>
                <div class="d-flex justify-content-between mt-1">
                  <h6 class="text-muted small fst-italic mb-0 mt-1">$21.00 <del class="text-danger ms-2">$25.00</del>
                  </h6>
                  <ul class="list-unstyled text-warning mb-0">
                    <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                    <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                    <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                    <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                    <li class="list-inline-item"><i class="mdi mdi-star"></i></li>
                  </ul>
                </div>
              </div>
            </div>
          </ng-template>
        </owl-carousel-o>
        <!-- </div> -->
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>

  <div class="container-fluid mt-100 mt-60 px-0">
    <div class="py-5 bg-light">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-12">
            <div class="d-flex align-items-center justify-content-between">
              <a routerLink="/shop-product-detail" class="text-dark align-items-center">
                <span class="pro-icons"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" class="feather feather-arrow-left fea icon-sm">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                  </svg></span>
                <span class="text-muted d-none d-md-inline-block">Web Development</span>
                <img src="assets/images/work/6.jpg" class="avatar avatar-small rounded shadow ms-2" style="height:auto;"
                  alt="">
              </a>

              <a routerLink="/index" class="btn btn-lg btn-pills btn-icon btn-soft-primary"><svg
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="feather feather-home icons">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                  <polyline points="9 22 9 12 15 12 15 22"></polyline>
                </svg></a>

              <a routerLink="/shop-product-detail" class="text-dark align-items-center">
                <img src="assets/images/work/7.jpg" class="avatar avatar-small rounded shadow me-2" style="height:auto;"
                  alt="">
                <span class="text-muted d-none d-md-inline-block">Web Designer</span>
                <span class="pro-icons"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" class="feather feather-arrow-right fea icon-sm">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg></span>
              </a>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </div>
    <!--end div-->
  </div>
  <!--end container-->
</section>
<!--end section-->

<!-- Back to top -->
<a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
  <i-feather name="arrow-up" class="icons"></i-feather>
</a>
<!-- Back to top -->